// extracted by mini-css-extract-plugin
export default {"container":"TwoColumns_container__UTRtz","leftColumn":"TwoColumns_leftColumn__1bJ3x","rightColumn":"TwoColumns_rightColumn__BVVoW","title":"TwoColumns_title__4Txum"};